import React from 'react';
import Section from '@/components/Section';
import { PageSectionFieldsFragment, PageSectionsBySystemIdQuery } from '../../@types/generated';
import Popup from 'components/src/popup';
import { getOr } from '@/utils/options';
import RichTextSection from '@/components/RichTextSection/RichTextSection';
import { useCookieConsent } from '../hooks/useCookieConsent';
import Button from 'components/src/button';
import { useTranslation } from 'react-i18next';

type Props = {
  sections: Array<PageSectionsBySystemIdQuery>;
};

function renderText(pageSectionFragment: PageSectionFieldsFragment) {
  if (pageSectionFragment.children?.__typename === 'RichTextSection') {
    return (
      <Section
        childrenTypeName={pageSectionFragment.children?.__typename}
        sectionId={getOr(pageSectionFragment.id, '')}
        theme={getOr(pageSectionFragment.background, '')}
        marginTop={getOr(pageSectionFragment.marginTop, 0)}
        marginBottom={getOr(pageSectionFragment.marginBottom, 0)}
        gridType={getOr(pageSectionFragment.gridType as 'centered' | 'full', 'full')}
      >
        <RichTextSection data={pageSectionFragment.children} />
      </Section>
    );
  }
  return null;
}

const UmVafrakokurPage = ({ sections }: Props) => {
  const [showThankYouModal, setShowThankYouModal] = React.useState<boolean>(false);
  const pageSections = sections.flatMap((x) => x.pageSectionCollection?.items as PageSectionFieldsFragment[]);
  const { t } = useTranslation();
  const { cookieData } = useCookieConsent();
  const { openCookieSettings } = useCookieConsent();

  const handleModalClose = () => {
    setShowThankYouModal(false);
  };

  return (
    <>
      {pageSections.map((x) => renderText(x))}
      <Section
        childrenTypeName={undefined}
        sectionId=""
        theme={'default'}
        marginTop={16}
        marginBottom={128}
        gridType={'full'}
      >
        <div className="flex w-full flex-col gap-16 overflow-hidden">
          <div className="body-lg flex flex-col gap-16 ">
            <p id="CookieDeclarationIntro">{`${t('Cookies.DeclarationIntro')}: syn.is`}</p>
            <div id="CookieDeclarationConsentStates">
              <div id="CookieDeclarationConsentState">{`${t('Cookies.ConsentState')}: ( ${
                cookieData.cookieState
              } )`}</div>
              <div id="CookieDeclarationConsentId">{`${t('Cookies.ConsentId')}: ${cookieData.cookieId}`}</div>
              <div id="CookieDeclarationConsentDate">{`${t('Cookies.ConsentDate')}: ${cookieData.cookieDate}`}</div>
            </div>
          </div>
          <div className="cookie-settings body-lg flex flex-col gap-16">
            <p className="cookie-info">{t('Cookies.ConsentUpdate')}:</p>
            <div className="flex justify-center">
              <Button label="Uppfæra samþykki" id="cookie-button" onClick={openCookieSettings} />
            </div>
          </div>
        </div>
      </Section>
      <Popup
        isOpen={showThankYouModal}
        title={'Takk fyrir'}
        text={'Skilaboð móttekin. Þjónustufulltrúar Sýnar verða í sambandi við þig.'}
        buttonText={'Loka glugga'}
        variant={'content'}
        onClose={handleModalClose}
        onClick={handleModalClose}
      />
    </>
  );
};

export default UmVafrakokurPage;
